export default {
	SET_USER_ADDRESS: 'SET_USER_ADDRESS',
  SET_USER_ADDRESSES: 'SET_USER_ADDRESSES',
	REMOVE_USER_ADDRESSES_ITEM: 'REMOVE_USER_ADDRESSES_ITEM',
}
